import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SidebarProps {
  onCategorySelect?: (category: string) => void;
  /** Currently selected category for advanced filtering (optional) */
  activeCategoryId?: string | null;
  advancedFilters?: ReactNode;
  layoutToggle?: ReactNode;
}

export default function Sidebar({
  onCategorySelect: _onCategorySelect,
  activeCategoryId: _activeCategoryId,
  advancedFilters,
  layoutToggle,
}: SidebarProps) {
  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-[var(--color-background-paper)] border-r border-[var(--color-neutral-light-gray)] flex flex-col">
      <div className="p-4 border-b border-[var(--color-neutral-light-gray)]">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-primary-highlight)] bg-clip-text text-transparent hover:scale-105 transition-transform">
          Save For Later
        </h1>
      </div>

      <nav className="flex-1 overflow-y-auto p-4 min-h-0">
        {layoutToggle && (
          <div className="mt-6 pt-4 border-t border-[var(--color-neutral-light-gray)] min-w-0">
            <p className="px-1 mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-text-secondary)]">
              Layout
            </p>
            <div className="flex justify-center w-full min-w-0">{layoutToggle}</div>
          </div>
        )}

        {advancedFilters && (
          <div className="mt-6 border-t border-[var(--color-neutral-light-gray)] min-w-0">
            {advancedFilters}
          </div>
        )}
      </nav>

      <div className="p-4 border-t border-[var(--color-neutral-light-gray)] flex-shrink-0">
        <Link
          to="/account"
          className="w-full px-4 py-2 bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)] text-[var(--color-text-inverse)] rounded-lg transition-colors flex items-center justify-center gap-2"
        >
          <span className="text-xl">👤</span>
          <span>My Account</span>
        </Link>
      </div>
    </aside>
  );
}
